import {callAPI, createActions} from '../../../../commons/actions/data-action-helper'
import {createAsyncAction} from '../services/redux-toolkit'
import {GetState} from '../types/state'

export const GET_CHECKOUT_OPTIONS_OLD = createActions('GET_CHECKOUT_OPTIONS_OLD')

export const getCheckoutOptionsOld = () => (dispatch: Function, getState: GetState) => {
  if (!getState().checkoutOptions.loaded) {
    return dispatch(callAPI(GET_CHECKOUT_OPTIONS_OLD))
  } else {
    return Promise.resolve()
  }
}

export const getCheckoutOptions = createAsyncAction(
  'GET_CHECKOUT_OPTIONS',
  async (_, {getState, extra: {serverApi}}) => {
    if (!getState().checkoutOptions.loaded) {
      return serverApi.getCheckoutOptions()
    } else {
      return Promise.resolve()
    }
  },
)
